<template>
  <v-container>
    <simpleRoulette
    v-if="!this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRoulette>
    <simpleRouletteMobile
    v-if="this.$vuetify.breakpoint.smAndDown"
    v-bind:welcomeText = "welcomeText"
    v-bind:descText = "descText"
    v-bind:sideImg = "sideImg"
    v-bind:cards = "cards"
    ></simpleRouletteMobile>
  </v-container>
</template>

  <script>
    import simpleRoulette from '../../components/simpleRoulette';
    import simpleRouletteMobile from '../../components/simpleRouletteMobile';
  
      export default {
        name: 'simpleSissy',
        components: {
          simpleRoulette,
          simpleRouletteMobile,
        },
        data: () => ({
          welcomeText: "Welcome to simple sissy!",
          descText: "In this simple roulette, you will roll for your outfit(cumulative), and then one sissy task to help move you one step closer to shedding the little boy inside of you and embracing your inner woman!",
          sideImg: "https://i.imgur.com/Helun6o.png",
          cards:[
            {
              rollTitle: "Clothing",
              cumulative: true,
              items: [
                {
                  text: "Panties",
                  active: false
                },
                {
                  text: "Bra",
                  active: false
                },
                {
                  text: "Leggings",
                  active: false
                },
                {
                  text: "Heels",
                  active: false
                },
                {
                  text: "Skirt",
                  active: false
                },
                {
                  text: "Blouse",
                  active: false
                },
              ],
              rolled: false
            },
            {
              rollTitle: "Task",
              cumulative: false,
              items: [
                {
                  text: "Jerk A Dildo",
                  active: false
                },
                {
                  text: "Blow A Dildo",
                  active: false
                },
                {
                  text: "Deepthroat A Dildo",
                  active: false
                },
                {
                  text: "Fuck A Dildo Doggystyle",
                  active: false
                },
                {
                  text: "Fuck A Dildo Missionary",
                  active: false
                },
                {
                  text: "Fuck A Dildo Cowgirl",
                  active: false
                },
              ],
              rolled: false
            },
          ]
        }),
        methods: {
          roll() {
            this.cards.forEach(function(card) {
              card.rolled = true;
            })
          }
        },
      }
  </script>